import { render, staticRenderFns } from "./nutritionLibraryAdd.vue?vue&type=template&id=2913985b&scoped=true"
import script from "./nutritionLibraryAdd.vue?vue&type=script&lang=js"
export * from "./nutritionLibraryAdd.vue?vue&type=script&lang=js"
import style0 from "./nutritionLibraryAdd.vue?vue&type=style&index=0&id=2913985b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913985b",
  null
  
)

export default component.exports